<template>
    <div class="container-fluid">
        <el-row>
            <el-col :span="24" class="d-flex align-items-start justify-content-center">
                <img src="../assets/semPermissao.svg" class="img-fluid" style="max-width: 400px; margin-top: 100px;">
            </el-col>
            <el-col :span="24" class="d-flex align-items-start justify-content-center">
                <h4 style="color: #343a40">Ops, você não tem permissão para acessar essa página</h4>
            </el-col>
        </el-row> 
    </div>   
</template>

<script>
export default {
    
}
</script>

<style>
    img{
        width: 35%;
    }

</style>